(function () {
  const TRACKING_PARAMETERS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_referrer',
    'irclickid', // impact.com attribution click id
    'im_ref' // impact.com click id (alias of irclickid)
  ];
  const CANADIAN_STORE_DOMAIN = 'hush.ca';
  const CANADIAN_LINK_SELECTOR = `a[href*="${CANADIAN_STORE_DOMAIN}"]`;
  const STORAGE_KEY = 'hush_tracking_parameters';
  const COOKIE_MAX_AGE_SECONDS = 2592000; // 30 days
  const GEOLIZR_REDIRECT_PREFIX = 'GeolizrRedirect=>';
  const CLICK_ID_PARAMETERS = new Set(['irclickid', 'im_ref']);

  function readCookieParameters() {
    try {
      const prefix = `${STORAGE_KEY}=`;
      const match = document.cookie.split('; ').find(row => row.startsWith(prefix));
      if (!match) {
        return {};
      }

      return JSON.parse(decodeURIComponent(match.slice(prefix.length))) || {};
    } catch (error) {
      console.error('Error reading stored tracking parameters:', error);
      return {};
    }
  }

  function storeParameters(parameters) {
    try {
      document.cookie = [
        `${STORAGE_KEY}=${encodeURIComponent(JSON.stringify(parameters))}`,
        `Max-Age=${COOKIE_MAX_AGE_SECONDS}`,
        'Path=/',
        'SameSite=Lax'
      ].join('; ');
    } catch (error) {
      console.error('Error storing tracking parameters:', error);
    }
  }

  function mirrorClickIds(parameters, currentParameters = {}) {
    const clickId =
      currentParameters.irclickid ||
      currentParameters.im_ref ||
      parameters.irclickid ||
      parameters.im_ref;

    if (!clickId) {
      return parameters;
    }

    return {
      ...parameters,
      irclickid: clickId,
      im_ref: clickId
    };
  }

  const storedParameters = readCookieParameters();
  const currentUrlParams = new URLSearchParams(window.location.search);
  const currentParameters = {};
  TRACKING_PARAMETERS.forEach(param => {
    const value = currentUrlParams.get(param);
    if (value) {
      currentParameters[param] = value;
    }
  });

  const trackingParametersToCarryOver = mirrorClickIds(
    {
      ...storedParameters,
      ...currentParameters
    },
    currentParameters
  );

  if (JSON.stringify(trackingParametersToCarryOver) !== JSON.stringify(storedParameters)) {
    storeParameters(trackingParametersToCarryOver);
  }

  if (Object.keys(trackingParametersToCarryOver).length === 0) {
    return;
  }

  function isCanadianStoreHostname(hostname) {
    return hostname === CANADIAN_STORE_DOMAIN || hostname.endsWith(`.${CANADIAN_STORE_DOMAIN}`);
  }

  function isCanadianStoreLink(link) {
    return isCanadianStoreHostname(link.hostname);
  }

  function applyTrackingParameters(urlString) {
    const linkUrl = new URL(urlString, window.location.origin);
    if (
      !['https:', 'http:'].includes(linkUrl.protocol) ||
      !isCanadianStoreHostname(linkUrl.hostname)
    ) {
      return null;
    }

    Object.entries(trackingParametersToCarryOver).forEach(([param, value]) => {
      // Keep destination UTMs (e.g. Geolizr's utm_source=hushblankets.com); always set click ids.
      if (!CLICK_ID_PARAMETERS.has(param) && linkUrl.searchParams.has(param)) {
        return;
      }

      linkUrl.searchParams.set(param, value);
    });

    return linkUrl.toString();
  }

  function addTrackingParametersToLink(link) {
    if (link.dataset.trackingParamsAdded || !isCanadianStoreLink(link)) {
      return;
    }

    const taggedUrl = applyTrackingParameters(link.href);
    if (!taggedUrl) {
      return;
    }

    link.href = taggedUrl;
    link.dataset.trackingParamsAdded = 'true';
  }

  function updateCanadianStoreDomainLinks() {
    document.querySelectorAll(CANADIAN_LINK_SELECTOR).forEach(addTrackingParametersToLink);
  }

  function tagGeolizrPopupIframeLinks() {
    const iframe = document.getElementById('geolizr-popup-content-iframe');
    if (!iframe) {
      return false;
    }

    try {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      if (!iframeDocument) {
        return false;
      }

      const links = iframeDocument.querySelectorAll(CANADIAN_LINK_SELECTOR);
      if (links.length === 0) {
        return false;
      }

      links.forEach(addTrackingParametersToLink);
      return true;
    } catch (error) {
      // Cross-origin iframe content is not readable.
      return false;
    }
  }

  function onGeolizrPopupShow() {
    updateCanadianStoreDomainLinks();

    // Geolizr writes popup HTML into the iframe asynchronously after popup.show.
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (tagGeolizrPopupIframeLinks() || attempts >= 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function patchReplaceUrlPlaceholder(object, key) {
    const original = object[key];
    if (typeof original !== 'function' || original.__hushImpactPatched) {
      return;
    }

    const patched = function patchedReplaceUrlPlaceholder() {
      const resolved = original.apply(this, arguments);
      try {
        return applyTrackingParameters(resolved) || resolved;
      } catch (error) {
        console.error('Error tagging Geolizr placeholder URL:', error);
        return resolved;
      }
    };

    patched.__hushImpactPatched = true;
    object[key] = patched;
  }

  function patchGeolizrUrlHelpers() {
    if (window.Geolizr) {
      patchReplaceUrlPlaceholder(window.Geolizr, 'replaceUrlPlaceholder');
    }

    // Newer Geolizr builds expose helpers under Geolizr.helper / helper.helper.
    if (window.Geolizr && window.Geolizr.helper) {
      patchReplaceUrlPlaceholder(window.Geolizr.helper, 'replaceUrlPlaceholder');
    }
  }

  let geolizrPopupListenerRegistered = false;

  function catchUpIfPopupAlreadyOpen() {
    const popupAlreadyOpen =
      document.getElementById('geolizr-popup-content-iframe') ||
      document.getElementById('geolizr-popup') ||
      (window.Geolizr && window.Geolizr.activePopup);

    if (popupAlreadyOpen) {
      onGeolizrPopupShow();
    }
  }

  function registerGeolizrPopupListener() {
    patchGeolizrUrlHelpers();

    if (!window.Geolizr || typeof window.Geolizr.addEventListener !== 'function') {
      return false;
    }

    if (!geolizrPopupListenerRegistered) {
      // Geolizr re-dispatches popup.show immediately when activePopup is already set,
      // so late registration still runs after a race where the popup opened first.
      window.Geolizr.addEventListener('popup.show', onGeolizrPopupShow);
      geolizrPopupListenerRegistered = true;
    }

    catchUpIfPopupAlreadyOpen();
    return true;
  }

  registerGeolizrPopupListener();

  // Geolizr app embed often loads after this deferred theme script.
  const geolizrPatchTimer = setInterval(() => {
    if (registerGeolizrPopupListener()) {
      clearInterval(geolizrPatchTimer);
    }
  }, 100);
  setTimeout(() => clearInterval(geolizrPatchTimer), 15000);

  function isTrustedGeolizrMessage(event) {
    const iframe = document.getElementById('geolizr-popup-content-iframe');
    if (!iframe || !iframe.contentWindow || event.source !== iframe.contentWindow) {
      return false;
    }

    try {
      return event.origin === iframe.contentWindow.location.origin;
    } catch (error) {
      // Cross-origin iframe: trust only the origin of the configured iframe src.
      if (!iframe.src) {
        return event.origin === window.location.origin;
      }

      try {
        return event.origin === new URL(iframe.src, window.location.href).origin;
      } catch (urlError) {
        return false;
      }
    }
  }

  // Backup: postMessage redirects (when the CTA does not use target="_parent").
  window.addEventListener(
    'message',
    event => {
      if (!isTrustedGeolizrMessage(event)) {
        return;
      }

      const data = event.data;
      if (typeof data !== 'string' || !data.startsWith(GEOLIZR_REDIRECT_PREFIX)) {
        return;
      }

      const rawUrl = data.slice(GEOLIZR_REDIRECT_PREFIX.length);
      if (!rawUrl) {
        return;
      }

      try {
        let destination = rawUrl;
        if (
          window.Geolizr &&
          typeof window.Geolizr.hasUrlPlaceholder === 'function' &&
          window.Geolizr.hasUrlPlaceholder(destination)
        ) {
          destination = window.Geolizr.replaceUrlPlaceholder(destination);
        }

        const taggedUrl = applyTrackingParameters(destination);
        if (!taggedUrl) {
          return;
        }

        event.stopImmediatePropagation();
        window.location.href = taggedUrl;
      } catch (error) {
        console.error('Error tagging Geolizr redirect URL:', error);
      }
    },
    true
  );

  // Tag existing anchors before browser-native navigation.
  updateCanadianStoreDomainLinks();

  // Fallback for any hush.ca anchors in the parent document.
  document.addEventListener('click', event => {
    const clickedLink = event.target.closest(CANADIAN_LINK_SELECTOR);
    if (clickedLink) {
      addTrackingParametersToLink(clickedLink);
    }
  });
})();
